import { useQuery } from "@tanstack/react-query";
import { rolesClient } from "@users/rolesClient";

const rolesKeys = {
  list: (sessionKey: string) => ["roles", sessionKey] as const,
};

/** Non-suspense and best-effort: callers only want an optional display name. */
export const useClinicRoles = (sessionKey: string) =>
  useQuery({
    queryKey: rolesKeys.list(sessionKey),
    queryFn: () => rolesClient.list(),
  });
